export let ifCond = (v1, operator, v2, options) => {
	switch (operator) {
		case '==':
			return (v1 == v2) ? options.fn(this) : options.inverse(this);
		case '===':
			return (v1 === v2) ? options.fn(this) : options.inverse(this);
		case '!=':
			return (v1 != v2) ? options.fn(this) : options.inverse(this);
		case '!==':
			return (v1 !== v2) ? options.fn(this) : options.inverse(this);
		case '<':
			return (v1 < v2) ? options.fn(this) : options.inverse(this);
		case '<=':
			return (v1 <= v2) ? options.fn(this) : options.inverse(this);
		case '>':
			return (v1 > v2) ? options.fn(this) : options.inverse(this);
		case '>=':
			return (v1 >= v2) ? options.fn(this) : options.inverse(this);
		case '&&':
			return (v1 && v2) ? options.fn(this) : options.inverse(this);
		case '||':
			return (v1 || v2) ? options.fn(this) : options.inverse(this);
		default:
			return options.inverse(this);
	}
};

export let math = (lvalue, operator, rvalue) => {
	lvalue = parseFloat(lvalue);
	rvalue = parseFloat(rvalue);
	return {
		'+': lvalue + rvalue,
		'-': lvalue - rvalue,
		'*': lvalue * rvalue,
		'/': lvalue / rvalue,
		'%': lvalue % rvalue
	}[operator];
};

export let checkIf = (v1, o1, v2, mainOperator, v3, o2, v4, options) => {
	var operators = {
		'==': (a, b) => a==b,
		'===': (a, b) => a===b,
		'!=': (a, b) => a!=b,
		'!==': (a, b) => a!==b,
		'<': (a, b) => a<b,
		'<=': (a, b) => a<=b,
		'>': (a, b) => a>b,
		'>=': (a, b) => a>=b,
		'&&': (a, b) => a&&b,
		'||': (a, b) => a||b,
	}
	let a1 = operators[o1](v1,v2);
	let a2 = operators[o2](v3,v4);
	let isTrue = operators[mainOperator](a1, a2);
	return isTrue ? options.fn(this) : options.inverse(this);
};

export let object = ({ hash }) => {
	return hash;
};

export let placeholderImage = (width, height) => {
	const svg = encodeURIComponent('<svg width="' + width + '" height="' + height + '" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ' + width + ' ' + height + '" preserveAspectRatio="none"><rect width="100%" height="100%" fill="#F3F3F3" fill-opacity="0"></rect></svg>');
	return 'data:image/svg+xml;charset=UTF-8,' + svg;
};

// Handlebars.registerHelper('ifIsNthItem', function(options) {
// 	var index = options.data.index + 1,
// 		nth = options.hash.nth;
  
// 	if (index % nth === 0) 
// 	  return options.fn(this);
// 	else
// 	  return options.inverse(this);
//   });
  